import { render } from "./DocumentsFiles.vue?vue&type=template&id=11068f73&ts=true"
import script from "./DocumentsFiles.vue?vue&type=script&lang=ts"
export * from "./DocumentsFiles.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__